import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import * as PR from "../../prime-react/index";
import {
  getGroups,
  getPlayers,
  getSports,
  getLocations,
  getTournament,
  getGroupsbyRole,
  getTournamentLevels,
  geteSportsTitles
} from "../../services/api";
import { useDispatch, useSelector } from "react-redux";
import { formatShortDate, formatDateRange, getRoleIds, queryLimit } from "../../utils/reuse";
import { useLocation } from "react-router-dom";
import { filterOptionsActions } from "../../store/FiltersOptions";
import SavedFilters from "./SavedFilters";
const SearchFilter = ({
  alertsActiveIndex,
  setFilters,
  staticOptionData,
  setFilterDialogVisible,
  selectedFilters,
  screenType
}) => {
  const dispatch = useDispatch();
  const pathname = window.location.pathname;
  const location = useLocation();

  const [checkedReportTypes, setCheckedReportTypes] = useState({});
  const [checkedReceivers, setCheckedReceivers] = useState({});
  const [receivers, setReceivers] = useState([]);
  const [receiverSearch, setReceiverSearch] = useState("");
  const [filteredReceivers, setFilteredReceivers] = useState([]);
  const sessionData = useSelector((state) => state.auth.sessionData);
  const filterOptions = useSelector((state) => state.filterOptions);
  const role = sessionData?.role;
  const doesReportScreen = screenType === 'reports';
  const doesAlertsScreen = screenType === 'alerts';
  const isCompanyTabDisabled = ((role === "member" || role === "managedmember")&& pathname === "/alerts" && alertsActiveIndex === 3)

  const [error, setError] = useState(null)
  const [disableeSportsTitles, setDisableeSportsTitles] = useState(true);
  const [disableTournamentLevel, setDisableTournamentLevel] = useState(true);
  const [keywords, setKeywords] = useState(selectedFilters?.keyword??'');

    /** Sports */
  const [sports, setSports] = useState([]);
  const [filteredSports, setFilteredSports] = useState([]);
  const [checkedSports, setCheckedSports] = useState({});
  const [sportIds, setSportIds] = useState([]);

   /** eSports Titles */
   const [eSportsTitleList, seteSportsTitleList] = useState([]);
   const [eSportTitleSearch, setESportTitleSearch] = useState("");
   const [filteredeSportsTitles, setFilteredeSportsTitles] = useState([]);
   const [checkedeSportsTitles, setCheckedeSportsTitles] = useState({});

  /** Date */
  const [date, setDate] = useState([new Date(), new Date()]);
  const [dateRange, setDateRange] = useState("");
  /** Event Date */
  const [eventDate, setEventDate] = useState([new Date(), new Date()]);
  const [eventDateRange, setEventDateRange] = useState("");

   /** Location */
  const [locations, setLocations] = useState([]);
  const [states, setStates] = useState([]);
  const [searchSports, setSearchSports] = useState('');
  const [filteredLocations, setFilteredLocations] = useState([]);
  const [filteredStates, setFilteredStates] = useState([]);
  const [filteredCustomerLocations, setFilteredCustomerLocations] = useState([]);
  const [filteredSuspiciousCustomerLocations, setFilteredSuspiciousCustomerLocations] = useState([]);
  const [suspiciousCustomerStates, setSuspiciousCustomerStates] = useState([]);
  const [filteredSuspiciousCustomerStates, setFilteredSuspiciousCustomerStates] = useState([]);
  const [locatinSearch, setLocationSearch] = useState("");
  const [customerLocationSearch, setCustomerLocationSearch] = useState("");
  const [suspiciousCustomerLocationSearch, setSuspiciousCustomerLocationSearch] = useState("");
  const [stateSearch, setStateSearch] = useState("");
  const [suspiciousCustomerStateSearch, setSuspiciousCustomerStateSearch] = useState("");
  const [checkedLocations, setCheckedLocations] = useState({});
  const [checkedCustomerLocations, setCheckedCustomerLocations] = useState({});
  const [checkedSuspiciousCustomerLocations, setCheckedSuspiciousCustomerLocations] = useState({});
  const [checkedStates, setCheckedStates] = useState({});
  const [checkedSuspiciousCustomerStates, setCheckedSuspiciousCustomerStates] = useState({});
  const [loading, setLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedSavedFilter, setSelectedSavedFilter] = useState(null);

  const headers = useMemo(() => {
    return { sessionid: sessionData.sessionId };
  }, [sessionData.sessionId]);

  useEffect(() => {
    const selectedSportIds = selectedFilters?.sports?.map((sport) => sport.id);
    setSportIds(selectedSportIds);
    selectedFilters?.combinedStatus?.forEach(({ id }) => {
      setCheckedStatus((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    });

    selectedFilters?.tags?.forEach(({ id }) => {
      setCheckedPlayers((prevState) => ({
        ...prevState,
        [id]: true,
      }));
      setCheckedMarketTags((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    });
    selectedFilters?.sports?.forEach(({ id }) => {
      setCheckedSports((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    });

    selectedFilters?.eSportsTitles?.forEach(({ id }) => {
      setCheckedeSportsTitles((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    });

    selectedFilters?.tournamentLevels?.forEach(({ id }) => {
      setCheckedTournamentLevels((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    });

    selectedFilters?.alertType?.forEach(({ id }) => {
      setCheckedAlerts((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    });

    selectedFilters?.company?.forEach(({ id }) => {
      setCheckedCompanies((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    });

    selectedFilters?.responseType?.forEach(({ id }) => {
      setCheckedResponses((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    });
    if(selectedFilters?.date?.date?.length){
      setDate(selectedFilters?.date?.date);
    }
    if(selectedFilters?.date?.dateRange){
      setDateRange(selectedFilters?.date?.dateRange);
    }
    if(selectedFilters?.eventDate?.date?.length){
      setEventDate(selectedFilters?.eventDate?.date);
    }
    if(selectedFilters?.eventDate?.dateRange){
      setEventDateRange(selectedFilters?.eventDate?.dateRange);
    }

    selectedFilters?.gender?.forEach(({ id }) => {
      setCheckedGenders((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    });

    selectedFilters?.tournament?.forEach(({ id }) => {
      setCheckedTournaments((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    });

    selectedFilters?.location?.forEach(({ id }) => {
      setCheckedLocations((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    });
    selectedFilters?.customerLocations?.forEach(({ id }) => {
      setCheckedCustomerLocations((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    });
    selectedFilters?.suspiciousCustomerLocations?.forEach(({ id }) => {
      setCheckedSuspiciousCustomerLocations((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    });
    selectedFilters?.suspiciousCustomerStates?.forEach(({ id }) => {
      setCheckedSuspiciousCustomerStates((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    });
    selectedFilters?.channel?.forEach(({ id }) => {
      setCheckedChannel((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    });

    selectedFilters?.timeOfBet?.forEach(({ id }) => {
      setCheckedTimeOfBet((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    });

    selectedFilters?.stateOfBet?.forEach(({ id }) => {
      setCheckedStateOfBet((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    });

    selectedFilters?.timeOfAlert?.forEach(({ id }) => {
      setCheckedAlertsRaised((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    });

    if (selectedFilters?.maxBets?.length > 0) {
      setCheckedMaxBet(selectedFilters?.maxBets[0].id);
    }

    selectedFilters?.reportType?.forEach(({ id }) => {
      setCheckedReportTypes((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    });

    selectedFilters?.receiver?.forEach(({ id }) => {
      setCheckedReceivers((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    });
    if(selectedFilters?.selectedSavedFilter){
      setSelectedSavedFilter(selectedFilters.selectedSavedFilter);
    }
  }, [selectedFilters]);

  // Listing all the selected report type values
  const getSelectedReportTypes = () => {
    return staticOptionData?.reportTypeFilter?.filter(
      (item) => checkedReportTypes[item.id]
    );
  };

  /** End Report Type */

  // Listing all the selected receiver values
  const getSelectedReceivers = () => {
    return receivers?.filter((item) => checkedReceivers[item.id]);
  };


  /** End Receiver */

  /** Status */
  const getStatusOptions = () => {
    if ((role === "analyst" && pathname === "/suspicious-alerts") ||
      // in allalerts screen when navigated to Suspicious alerts tab : alertsActiveIndex === 1
      ((role === "member" || role === "managedmember") && pathname === "/alerts" && alertsActiveIndex === 1)) {
      return staticOptionData.combinedStatus.filter((status) => {
        return (status.id.includes("underinvestigation") || status.id.includes("closed") || status.id.includes("sanctioned"))
      })
      // in allalerts screen when navigated to Required-action tab : alertsActiveIndex === 2
    } else if (role === "member" && pathname === "/alerts" && alertsActiveIndex === 2) {
      return staticOptionData.combinedStatus.filter((status) => {
        return !(status.id.includes("-"))
      })
    } else {
      return staticOptionData.combinedStatus
    }
  }
  const [status] = useState(getStatusOptions());
  const [checkedStatus, setCheckedStatus] = useState({});

  // Listing all the selected status values
  const getSelectedStatus = () => {
    return status?.filter((item) => checkedStatus[item.id]);
  };

  /** End Status */

  /** Player/ Team */
  const [playerNames, setPlayerNames] = useState([]);
  const [filteredPlayers, setFilteredPlayers] = useState([]);
  const [playerSearch, setPlayerSearch] = useState("");
  const [checkedPlayers, setCheckedPlayers] = useState({});

  // Get list of all the Players
  const getPlayerOrTeam = useCallback(() => {
    if(filterOptions.playerOrTermNameOptions?.length === 0){
      setLoading(true);
      getPlayers({ "categories[]": "athleteteam" }, headers, dispatch, (response) => {
        if (response.result === "SUCCESS") {
          const responseData = response.data;
          const Players = responseData;
          const result = Players?.length > 0 ? Players?.sort((a, b) => a.name.localeCompare(b.name)) : [];
          dispatch(filterOptionsActions.storeFilterOptions({key: 'playerOrTermNameOptions', options: result}));
          setPlayerNames(result);
          setFilteredPlayers(result);
        } else {
          setPlayerNames([]);
        }
        setLoading(false);
      });
    } else {
      setPlayerNames(filterOptions.playerOrTermNameOptions);
      setFilteredPlayers(filterOptions.playerOrTermNameOptions);
    }
  }, [dispatch, filterOptions.playerOrTermNameOptions, headers]);

  // Listing all the selected status values
  const getSelectedPlayers = () => {
    return playerNames.filter((item) => checkedPlayers[item.id]);
  };

  /** End Player/ Team */

  /** Market Tags */
  const [marketTags, setMarketTags] = useState([]);
  const [filteredMarketTags, setFilteredMarketTags] = useState([]);
  const [marketTagSearch, setMarketTagSearch] = useState("");
  const [checkedMarketTags, setCheckedMarketTags] = useState({});

  // Get list of all the Market Tags
  const getMarketTagsHandler = useCallback(() => {
    if(!filterOptions.marketTagOptions || filterOptions.marketTagOptions?.length === 0){
      setLoading(true);
      getPlayers({ "categories[]": "market" }, headers, dispatch, (response) => {
        if (response.result === "SUCCESS") {
          const responseData = response.data;
          const Tags = responseData;
          const result = Tags?.length > 0 ? Tags?.sort((a, b) => a.name.localeCompare(b.name)) : [];
          dispatch(filterOptionsActions.storeFilterOptions({key: 'marketTagOptions', options: result}));
          setMarketTags(result);
          setFilteredMarketTags(result);
        } else {
          setMarketTags([]);
        }
        setLoading(false);
      });
    } else {
      setMarketTags(filterOptions.marketTagOptions);
      setFilteredMarketTags(filterOptions.marketTagOptions);
    }
  }, [dispatch, filterOptions.marketTagOptions, headers]);

  // Listing all the selected market tag values
  const getSelectedMarketTags = () => {
    return marketTags.filter((item) => checkedMarketTags[item.id]);
  };

  /** Sports */

  const getSportsHandler = useCallback(() => {
    if(filterOptions.sportFilterOptions?.length === 0 || (filterOptions.sportActiveIndex !== alertsActiveIndex)){
    setLoading(true);
    getSports(alertsActiveIndex, headers, dispatch, (response) => {
      if (response.result === "SUCCESS") {
        const responseData = response.data;
        const sports = responseData;
        const result = sports?.length > 0 ? sports?.sort((a, b) => a.name.localeCompare(b.name)) : [];
        setSports(result);
        setFilteredSports(result);
        dispatch(filterOptionsActions.storeFilterOptions({ key: 'sportFilterOptions', options: result}))
        dispatch(filterOptionsActions.storeFilterOptions({ key: 'sportActiveIndex', options: alertsActiveIndex }));
      } else {
        setSports([]);
        setFilteredSports([])
      }
      setLoading(false);
    });
    } else {
      setSports(filterOptions.sportFilterOptions);
      setFilteredSports(filterOptions.sportFilterOptions);
    }
  }, [alertsActiveIndex, dispatch, filterOptions.sportActiveIndex, filterOptions.sportFilterOptions, headers]);

  // Checkbox handler to list all the selected values
  const sportFilterHandler = ({ id, checked }) => {
    const selectedSportIds = sports
      .filter((item) => {
        if (id === item.id) {
          return checked;
        }
        return checkedSports[item.id];
      })
      .map((item) => item.id);
    setSportIds(selectedSportIds);
    const sportNames = sports?.filter(s => selectedSportIds.includes(s.id)).map(s => s.name);
    if (!sportNames?.includes('Tennis')) {
      setCheckedTournamentLevels({})
      setFilteredTournamentLevels([]);
    }
  }
  // Listing all the selected sport values
  const getSelectedSports = () => {
    return sports.filter((item) => checkedSports[item.id]);
  };

  /** End Sports Team */


  /** eSports Titles */

  // Get list of all the eSports Titles
  const geteSportsTitlesHandler = useCallback(() => {
    if (filterOptions.eSportTitleOptions?.length === 0) {
      geteSportsTitles(headers, dispatch, (response) => {
        if (response.result === "SUCCESS") {
          const responseData = response.data;
          const eSportsTitles = responseData;
          const result = eSportsTitles?.length > 0 ? eSportsTitles?.sort((a, b) => a.name.localeCompare(b.name)) : [];
          dispatch(filterOptionsActions.storeFilterOptions({ key: 'eSportTitleOptions', options: result }))
          seteSportsTitleList(result);
          setFilteredeSportsTitles(result);
        } else {
          seteSportsTitleList([]);
          setFilteredeSportsTitles([]);
        }
      });
    } else {
      seteSportsTitleList(filterOptions.eSportTitleOptions);
      setFilteredeSportsTitles(filterOptions.eSportTitleOptions);
    }
  }, [dispatch, filterOptions.eSportTitleOptions, headers]);

  // Listing all the selected eSports Titles values
  const getSelectedeSportsTitles = () => {
    return eSportsTitleList?.filter((item) => checkedeSportsTitles[item.id]);
  };

  /** End eSports Titles */

    /** Tournment Levels */
    const [tournamentLevelsList, setTournamentLevelsList] = useState([]);
    const [filteredTournamentLevels, setFilteredTournamentLevels] = useState([]);
    const [tournmentSearch, setTournmentSearch] = useState("");
    const [checkedTournamentLevels, setCheckedTournamentLevels] = useState({});
  
    // Get list of all the tournaments
    const getTournamentLevelsHandler = useCallback(() => {
      if (filterOptions.tournmentLevelOptions?.length === 0 || (filterOptions.alertsActiveIndex !== alertsActiveIndex)) {
        getTournamentLevels(alertsActiveIndex, headers, dispatch, (response) => {
          if (response.result === "SUCCESS") {
            const responseData = response.data;
            const tournamentLevels = responseData;
            const result = tournamentLevels?.length > 0 ? tournamentLevels?.sort((a, b) => a.name.localeCompare(b.name)) : [];
            dispatch(filterOptionsActions.storeFilterOptions({ key: 'tournmentLevelOptions', options: result }));
            dispatch(filterOptionsActions.storeFilterOptions({ key: 'alertsActiveIndex', options: alertsActiveIndex }));
            setTournamentLevelsList(result);
            setFilteredTournamentLevels(result);
          } else {
            setTournamentLevelsList([]);
            setTournamentLevelsList([]);
          }
        });
      } else {
        setTournamentLevelsList(filterOptions.tournmentLevelOptions);
        setFilteredTournamentLevels(filterOptions.tournmentLevelOptions);
      }
    }, [alertsActiveIndex, dispatch, filterOptions.alertsActiveIndex, filterOptions.tournmentLevelOptions, headers]);
  

    // Listing all the selected Tournament values
    const getSelectedTournamentLevels = () => {
      return tournamentLevelsList?.filter((item) => checkedTournamentLevels[item.id]);
    };
    /** End Tournment Levels */

  /** Alert Type */
  const [alertTypes] = useState(staticOptionData?.alertTypeFilter);
  const [checkedAlerts, setCheckedAlerts] = useState({});

  // Listing all the selected alert values
  const getSelectedAlerts = () => {
    return alertTypes?.filter((item) => checkedAlerts[item.id]);
  };
  /** End Alert Type */

  /** Response Type */
  const [responseTypes] = useState(staticOptionData?.responseTypeFilter?.filter(type => type.id !== 'all'));
  const [checkedResponses, setCheckedResponses] = useState({});

  // Listing all the selected response values
  const getSelectedResponses = () => {
    return responseTypes?.filter((item) => checkedResponses[item.id]);
  };
  /** End Response Type */


  /** Company Tab */
  const [companies, setCompanies] = useState([]);
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [companySearch, setCompanySearch] = useState("");
  const [checkedCompanies, setCheckedCompanies] = useState({});
  // Get list of all the members
  const getCompany = useCallback(() => {
    if(filterOptions.companyFilterOptions?.length === 0){
      setLoading(true);
      getGroups(getRoleIds(sessionData.role), headers, dispatch, (response) => {
        if (response.result === "SUCCESS") {
          const responseData = response.data;
          const members = responseData;
          const result = members?.length > 0 ? members?.sort((a, b) => a.name.localeCompare(b.name))  : [];
          dispatch(filterOptionsActions.storeFilterOptions({key: 'companyFilterOptions' , options: result}))
          setCompanies(result);
          setFilteredCompanies(result);
        } else {
          setCompanies([]);
        }
        setLoading(false);
      });
    } else {
      setCompanies(filterOptions.companyFilterOptions);
      setFilteredCompanies(filterOptions.companyFilterOptions);
    }
  }, [filterOptions.companyFilterOptions, sessionData.role, headers, dispatch]);

  // Listing all the selected response values
  const getSelectedCompanies = () => {
    return companies?.filter((item) => checkedCompanies[item.id]);
  };

  /** End Company */


  const handleDateRange = (e) => {
    setDate(e.value);
    if (e.value && e.value[0] !== null && e.value[1] === null) {
      let [startDate, endDate] = [e.value[0], e.value[0]]
      setDateRange(`${formatShortDate(startDate)} - ${formatShortDate(endDate)}`)
    } else if (e.value && e.value[0] !== null && e.value[1] !== null) {
      let [startDate, endDate] = e.value;
      setDateRange(
        `${formatShortDate(startDate)} - ${formatShortDate(endDate)}`
      );
    }
  };
  const handleEventDateRange = (e) => {
    setEventDate(e.value);
    if (e.value && e.value[0] !== null && e.value[1] === null) {
      let [startDate, endDate] = [e.value[0], e.value[0]]
      setEventDateRange(`${formatShortDate(startDate)} - ${formatShortDate(endDate)}`)
    } else if (e.value && e.value[0] !== null && e.value[1] !== null) {
      let [startDate, endDate] = e.value;
      setEventDateRange(
        `${formatShortDate(startDate)} - ${formatShortDate(endDate)}`
      );
    }

  };
  /** End Date */

  /** Tournament */
  const [tournamentsList, setTournamentList] = useState([]);
  const [filteredTournaments, setFilteredTournaments] = useState([]);
  const [leagueSearch, setLeagueSearch] = useState("");
  const [checkedTournaments, setCheckedTournaments] = useState({});

  // Get list of all the tournaments
  const getTournamenthandler = useCallback(() => {
    const obj = {
      sportid: sportIds.join(","),
    };
    getTournament(obj, headers, dispatch, (response) => {
      if (response.result === "SUCCESS") {
        const responseData = response.data;
        const tournaments = responseData;
        const result = tournaments?.length > 0 ? tournaments?.sort((a, b) => a.name.localeCompare(b.name)) : [];
        setTournamentList(result);
        setFilteredTournaments(result);
      } else {
        setTournamentList([]);
      }
    });
  }, [dispatch, headers, sportIds]);

  // Listing all the selected Tournament values
  const getSelectedTournaments = () => {
    return tournamentsList?.filter((item) => checkedTournaments[item.id]);
  };
  /** End Tournment */

  /** Gender */
  const [gender] = useState(staticOptionData?.gender);
  const [checkedGenders, setCheckedGenders] = useState({});


  // Listing all the selected gender values
  const getSelectedGenders = () => {
    return gender?.filter((item) => checkedGenders[item.id]);
  };
  /** End Gender */

 

  // Get list of all the locations
  const getLocationHandler = useCallback(() => {
    if(filterOptions.locationFilterOptions?.length === 0){
      setLoading(true);
      getLocations(headers, dispatch, (response) => {
        if (response.result === "SUCCESS") {
          const responseData = response.data;
          const locations = responseData;
          const result = locations?.length > 0 ? locations?.sort((a, b) => a.name.localeCompare(b.name)) : [];
          dispatch(filterOptionsActions.storeFilterOptions({key:'locationFilterOptions', options: result}))
          setLocations(result);
          setFilteredLocations(result);
          setFilteredCustomerLocations(result);
          setFilteredSuspiciousCustomerLocations(result);
        } else {
          setLocations([]);
        }
        setLoading(false);
      });
    } else {
      setLocations(filterOptions.locationFilterOptions);
      setFilteredLocations(filterOptions.locationFilterOptions);
      setFilteredCustomerLocations(filterOptions.locationFilterOptions);
      setFilteredSuspiciousCustomerLocations(filterOptions.locationFilterOptions);
    }
  }, [dispatch, filterOptions.locationFilterOptions, headers]);

  // Listing all the selected response values
  const getSelectedLocations = () => {
    return locations?.filter((item) => checkedLocations[item.id]);
  };
  const getSelectedCustomerLocations = () => {
    return locations?.filter((item) => checkedCustomerLocations[item.id]);
  };
  const getSelectedSuspiciousCustomerLocations = () => {
    return locations?.filter((item) => checkedSuspiciousCustomerLocations[item.id]);
  };
  const getSelectedStates = () => {
    return states?.filter((item) => checkedStates[item.id]);
  };
  const getSelectedSuspiciousCustomerStates = () => {
    return suspiciousCustomerStates?.filter((item) => checkedSuspiciousCustomerStates[item.id]);
  };

  /** End Location */

  /** Channel */
  const [channel] = useState(staticOptionData?.channels);
  const [checkedChannel, setCheckedChannel] = useState({});

  // Listing all the selected channel values
  const getSelectedChannels = () => {
    return channel?.filter((item) => checkedChannel[item.id]);
  };

  /** End Channel */

  /** Time of Bet */
  const [timeOfBet] = useState(staticOptionData?.timeOfBet);
  const [checkedTimeOfBet, setCheckedTimeOfBet] = useState({});

  // Listing all the selected timeOfBet values
  const getSelectedTimeOfBet = () => {
    return timeOfBet?.filter((item) => checkedTimeOfBet[item.id]);
  };


  /** End Time of Bet */

  /** State of Bet */
  const [stateOfBet] = useState(staticOptionData?.stateOfBetsFilter);
  const [checkedStateOfBet, setCheckedStateOfBet] = useState({});


  // Listing all the selected State of Bet values
  const getSelectedStateOfBets = () => {
    return stateOfBet?.filter((item) => checkedStateOfBet[item.id]);
  };

  /** End State of Bet */

  /** Max Bet */
  const [maxBet] = useState(staticOptionData?.maxBet);
  const [checkedMaxBet, setCheckedMaxBet] = useState("");

  // Checkbox handler to list all the selected values
  const maxBetRadioGroupHandler = (value) => {
    setCheckedMaxBet(value);
  };

  // Listing all the selected Max Bet values
  const getSelectedMaxBets = () => {
    return maxBet?.filter((item) => item.id === checkedMaxBet);
  };


  /** End Max Bet */

  /** Alert raised */
  const [alertsRaised] = useState(staticOptionData?.alertsRaised);
  const [checkedAlertsRaised, setCheckedAlertsRaised] = useState({});

  // Listing all the selected Alert Raised values
  const getSelectedAlertsRaised = () => {
    return alertsRaised?.filter((item) => checkedAlertsRaised[item.id]);
  };


  /** End Alert raised */

  // CombinedGroupbyroleId
  const GOVERNING_BODIES_ROLE = 4; // governing bodies
  const REGULATORS_ROLE = 3; // regulators

  const getGroup = useCallback(() => {
    if (filterOptions.receiverFilterOptions?.length === 0) {
      setLoading(true);
      getGroupsbyRole(GOVERNING_BODIES_ROLE, REGULATORS_ROLE, headers, dispatch, (response) => {
        if (response.result === "SUCCESS") {
          const responseData = response.data;
          const regulatorsAndSGB = responseData;
          const result = regulatorsAndSGB?.length > 0 ? regulatorsAndSGB?.sort((a, b) => a.name.localeCompare(b.name)).filter(r => r.status === 'active') : [];
          dispatch(filterOptionsActions.storeFilterOptions({ key: 'receiverFilterOptions', options: result }));
          setReceivers(result);
          setFilteredReceivers(result);
        } else {
          setFilteredReceivers([]);
        }
        setLoading(false);
      });
    } else {
      setReceivers(filterOptions.receiverFilterOptions);
      setFilteredReceivers(filterOptions.receiverFilterOptions);
    }
  }, [dispatch, filterOptions.receiverFilterOptions, headers]);

  const formattedDate = (dateVal) => {
    if (dateVal === undefined || dateVal.length === 0) {
      return []
    } else if (dateVal[1] === null && dateVal[0] !== null) {
      return [dateVal[0], dateVal[0]]
    } else if (dateVal[1] !== null && dateVal[0] !== null) {
      return dateVal
    }
    return [];
  }

  const getAlertStatus = () => {
    const alertStatuses = getSelectedStatus().map(item => {
      return item.id.split('-')[0]
    })
    const statusSet = [...new Set(alertStatuses)]
    const statusFiltered = statusSet.filter(item => item !== "")

    return statusFiltered.map(item => {
      return { id: item }
    })
  }

  const getCaseStatus = () => {

    const caseStatuses = getSelectedStatus().map(item => {
      return item.id.split('-')[1]
    })

    const statusSet = [...new Set(caseStatuses)]
    const statusFiltered = statusSet.filter(element => element !== undefined);

    return statusFiltered.map(item => {
      return { id: item }
    })
  }
  const [locationError,setLocationError] = useState('');
  const buildGlobalFilters = () => {
    return {
      combinedStatus: getSelectedStatus(),
      alertStatus: getAlertStatus(),
      caseStatus: getCaseStatus(),
      tags: [...getSelectedPlayers(), ...getSelectedMarketTags()],
      sports: getSelectedSports(),
      eSportsTitles: getSelectedeSportsTitles(),
      tournamentLevels: getSelectedTournamentLevels(),
      alertType: getSelectedAlerts(),
      responseType: getSelectedResponses(),
      company: getSelectedCompanies(),
      date: { date: dateRange ? formattedDate(date) : '', dateRange },
      eventDate: { date: eventDateRange ? formattedDate(eventDate) : '', dateRange: eventDateRange },
      tournament: getSelectedTournaments(),
      gender: getSelectedGenders(),
      location: getSelectedLocations(),
      customerLocations: getSelectedCustomerLocations(),
      customerStates: getSelectedStates(),
      suspiciousCustomerLocations: getSelectedSuspiciousCustomerLocations(),
      suspiciousCustomerStates: getSelectedSuspiciousCustomerStates(),
      reportType: getSelectedReportTypes(),
      receiver: getSelectedReceivers(),
      channel: getSelectedChannels(),
      timeOfBet: getSelectedTimeOfBet(),
      stateOfBet: getSelectedStateOfBets(),
      maxBets: getSelectedMaxBets(),
      timeOfAlert: getSelectedAlertsRaised(),
      keyword: keywords,
      selectedSavedFilter: selectedSavedFilter,
    };
  };
  const applyFilters = () => {
    if (getSelectedSports()?.length && getSelectedLocations()?.length) {
      const sports =  getSelectedSports().map(s => s.name);
      const locations =  getSelectedLocations().map(s => s.name);
      if(!sports.includes('eSports') && locations.includes('No Country')){
        setLocationError('Invalid Search')
        setTimeout(() => {
          setLocationError('')
        }, 2000)
        return;
      }
    }
    if(doesReportScreen && getSelectedReceivers().length > 10){
      setLocationError('You can select a maximum of 10 receivers.')
      setTimeout(() => {
        setLocationError('')
      }, 2000)
      return;
    }
    const global = buildGlobalFilters();
    setFilters(global);
    setFilterDialogVisible(false);
  };

  const othersTabFiltersSelected = () => {
    const filters = [
      getSelectedChannels(),
      getSelectedTimeOfBet(),
      getSelectedStateOfBets(),
      getSelectedMaxBets(),
      getSelectedAlertsRaised(),
    ];
    return filters?.some((filter) => filter?.length > 0);
  };
  const isPlayerVisible = useCallback(() => {
    if (role === "analyst") {
      if (doesReportScreen || (location.pathname === "/alerts")) {
        return false
      }
    }
    return true
  }, [doesReportScreen, location.pathname, role])

  const tabChangeHandler = (index) => {
    setActiveIndex(index);
  };
  useEffect(() => {
    getSportsHandler();
  }, [getSportsHandler])
  useEffect(() => {
    if (doesReportScreen) {
      getGroup();
    }
  }, [doesReportScreen, getGroup])
  useEffect(() => {
    if (doesAlertsScreen && !isCompanyTabDisabled) {
      getCompany();
    }
  }, [doesAlertsScreen, getCompany, isCompanyTabDisabled])
  useEffect(() => {
    if (doesAlertsScreen) {
      getLocationHandler();
    }
  }, [doesAlertsScreen, getLocationHandler])

  useEffect(() => {
    if (isPlayerVisible()) {
      getPlayerOrTeam();
      getMarketTagsHandler();
    }
  }, [getPlayerOrTeam, getMarketTagsHandler, isPlayerVisible]);

  useEffect(() => {
    const sportData = sportIds?.length ? sports.filter(s => sportIds?.includes(s.id)) : [];
    const sportNames = sportData.map(s => s.name);
    if (doesAlertsScreen) {
      if (sportNames.includes('Tennis')) {
        setDisableTournamentLevel(false);
        getTournamentLevelsHandler();
      } else if(sports.length){
        setDisableTournamentLevel(true);
        setTournamentLevelsList([]);
        setCheckedTournamentLevels({})
      }

      if(sportNames.includes('eSports')) {
        setDisableeSportsTitles(false);
        geteSportsTitlesHandler();
      } else if(sports.length){
        setDisableeSportsTitles(true);
        seteSportsTitleList([]);
        setCheckedeSportsTitles({})
      }
    }
  }, [doesAlertsScreen, getTournamentLevelsHandler, geteSportsTitlesHandler, sportIds, sports]);

  useEffect(() => {
    if (doesAlertsScreen) {
      if (sportIds?.length > 0) {
        getTournamenthandler();
      } else {
        setTournamentList([])
      }
    }
  }, [doesAlertsScreen, getTournamenthandler, sportIds]);


  const isStatusTabDisabled = (
    role === "analyst" &&
    (pathname === "/open-alerts" || pathname === "/evaluating-alerts")
  )
  //company search disabled for my-alerts

  const resetFilters = () => {
    setCheckedStatus({})
    setCheckedPlayers({})
    setCheckedMarketTags({})
    setCheckedSports({})
    setCheckedeSportsTitles({})
    setCheckedTournamentLevels({})
    setCheckedAlerts({})
    setCheckedResponses({})
    setCheckedCompanies({})
    setDate([new Date(), new Date()]);  
    setDateRange("");
    setEventDate([new Date(), new Date()]);
    setEventDateRange("");
    setCheckedTournaments({})
    setCheckedGenders({})
    setCheckedLocations({})
    setCheckedCustomerLocations({})
    setCheckedSuspiciousCustomerLocations({})
    setCheckedStates({})
    setCheckedSuspiciousCustomerStates({})
    setCheckedReportTypes({})
    setCheckedReceivers({})
    setCheckedChannel({})
    setCheckedTimeOfBet({})
    setCheckedStateOfBet({})
    setCheckedMaxBet('')
    setCheckedAlertsRaised({})
    setKeywords('')
    setDisableeSportsTitles(true);
    setDisableTournamentLevel(true);
    setSelectedSavedFilter(null);
    setSportIds([]);
    setStates([]);
    setSuspiciousCustomerStates([]);
  }
  const handleRemoveListFilter = (item, setter, type) => {
    setter((prevState) => {
      const updatedCheckedItems = { ...prevState };
      delete updatedCheckedItems[item.id]; // Assumes `item` has an `id` property
      return updatedCheckedItems;
    });
    if(type === 'sport'){
      sportFilterHandler({ id: item.id, checked: false })
    }
    if(type === 'locations'){
      getStatesHandler({ id: item.id, checked: false })
    }
    if(type === 'suspiciousLocations'){
      getSuspiciousCustomerStatesHandler({ id: item.id, checked: false })
    }
  };
  const handleRemoveItemFilter = (type) => {
    if(type === 'event'){
      setEventDateRange("");
      setEventDate([new Date(), new Date()]);
    } else if(type === 'date'){
      setDateRange("");
      setDate([new Date(), new Date()]);
    } else if (type === 'keyword'){
      setKeywords("")
    }
   
  };
  const handleCheckboxChange = (setter, type = '') => (e) => {
    const { value, checked } = e.target;
    setter((prevState) => ({
      ...prevState,
      [value]: checked,
    }));
    if(type === 'sport'){
      sportFilterHandler({ id: value, checked })
    }
    if(type === 'locations'){
      getStatesHandler({ id: value, checked })
    }
    if(type === 'suspiciousLocations'){
      getSuspiciousCustomerStatesHandler({ id: value, checked })
    }
  };
  const getStatesHandler = ({ id: value, checked }) => {
    const selectedLocationIds = locations
    .filter((item) => {
      if (value === item.id) {
        return checked;
      }
      return checkedCustomerLocations[item.id];
    })
    .map((item) => item.id);
    getStateList(selectedLocationIds)
  }
  const getSuspiciousCustomerStatesHandler = ({ id: value, checked }) => {
    const selectedLocationIds = locations
      .filter((item) => value === item.id ? checked : checkedSuspiciousCustomerLocations[item.id])
      .map((item) => item.id);
    getSuspiciousCustomerStateList(selectedLocationIds);
  };
  const getStateList = useCallback((selectedLocationIds, selectedStates = [], type = '') => {
    const locationIds = locations.filter(l => !!l.states).map(l => l.id);
    const stateIds = selectedLocationIds.filter(id => locationIds.includes(id))
    const states = locations.filter(l => stateIds.includes(l.id)).map(l => l.states).flat().map(name => ({ id: name, name }));
    setStates(states);
    setFilteredStates(states);
    if (states.length) {
      if (type) {
        const seletedStateIds = selectedStates.map(s => s.id);
        const checkedStates = states.reduce((acc, s) => {
          if (seletedStateIds.includes(s.id)) {
            acc[s.id] = true;
          }
          return acc;
        }, {});
        setCheckedStates(checkedStates)
      } else {
        setCheckedStates(previousSates => {
          const currentStates = states.reduce((acc, s) => {
            if (previousSates[s.id]) {
              acc[s.id] = true;
            }
            return acc;
          }, {});
          return currentStates;
        })
      }
    } else {
      setCheckedStates({})
    }
  }, [locations])
  const getSuspiciousCustomerStateList = useCallback((selectedLocationIds, selectedStates = [], type = '') => {
    const states = locations
      .filter((location) => selectedLocationIds.includes(location.id) && Array.isArray(location.states))
      .flatMap((location) => location.states)
      .map((name) => ({ id: name, name }));
    setSuspiciousCustomerStates(states);
    setFilteredSuspiciousCustomerStates(states);
    if (type) {
      const selectedStateIds = selectedStates.map((state) => state.id);
      setCheckedSuspiciousCustomerStates(states.reduce((checked, state) => {
        if (selectedStateIds.includes(state.id)) checked[state.id] = true;
        return checked;
      }, {}));
    } else {
      setCheckedSuspiciousCustomerStates((previousStates) => states.reduce((checked, state) => {
        if (previousStates[state.id]) checked[state.id] = true;
        return checked;
      }, {}));
    }
  }, [locations])
  useEffect(() => {
    if (selectedFilters?.customerLocations?.length) {
      const seletedLocationIds = selectedFilters?.customerLocations.map(l => l.id);
      getStateList(seletedLocationIds, selectedFilters.customerStates, 'onload')
    }
  }, [getStateList, selectedFilters?.customerLocations, selectedFilters.customerStates])
  useEffect(() => {
    if (selectedFilters?.suspiciousCustomerLocations?.length) {
      getSuspiciousCustomerStateList(
        selectedFilters.suspiciousCustomerLocations.map((location) => location.id),
        selectedFilters.suspiciousCustomerStates || [],
        'onload'
      );
    }
  }, [getSuspiciousCustomerStateList, selectedFilters?.suspiciousCustomerLocations, selectedFilters?.suspiciousCustomerStates])
  const handleSearch = (event, setSearch, dataList, setFilteredData) => {
    const searchedValue = event.target.value;
    setSearch(searchedValue);
    const filteredData =
      dataList &&
      dataList.filter((item) =>
        item.name.toLowerCase().includes(searchedValue.toLowerCase())
      );
    setFilteredData(filteredData);
  };
  const buttonSection = () => {
    return (
      <div className="flex flex-wrap justify-content-center gap-3 border-top">

        <PR.Button
          label="Reset Filters"
          outlined
          autoFocus
          className="logout-btns reset-btn"
          onClick={resetFilters}
        />
        <PR.Button
          label="Cancel"
          onClick={() => setFilterDialogVisible(false)}
          outlined
          className="logout-btns"
        />
        <PR.Button
          label="Apply Filters"
          outlined
          autoFocus
          className={role === 'analyst' ? 'logout-btns click-btn color-update' : 'logout-btns click-btn'}
          onClick={applyFilters}
        />
      </div>
    )
  }


  const OtherFilterList = ({ items, label, setter, type }) => {
    if (!items?.length) return null;
    return (
      <ul>
        <li className="mr-2">{label}: </li>
        {items.map((item, index) => (
          <li key={index}>
            <span>
              {item.name}{" "}
              <i
                className="pi pi-times"
                onClick={() => !type ? handleRemoveListFilter(item, setter, type) : setter("")}
              ></i>
            </span>
          </li>
        ))}
      </ul>
    );
  }
  const FiltersList = ({ items, label, setter, type }) => {
    if (!items?.length) return null;
    return (
      <div className="filters-list mb-3">
        <ul>
          <li className="block">{label}: </li>
          {items.map((item, index) => (
            <li key={index}>
              <span>
                {item.name}{" "}
                <i
                  className="pi pi-times"
                  onClick={() => handleRemoveListFilter(item, setter, type)}
                ></i>
              </span>
            </li>
          ))}
        </ul>
      </div>
    );
  }
  const FilterItem = ({ label, value, handleRemove }) => {
    if (!value) return null;
  
    return (
      <div className="filters-list mb-3">
        <ul>
          <li className="block">{label}: </li>
          <li>
            <span>
              {value}
              <i
                className="pi pi-times"
                onClick={handleRemove}
              ></i>
            </span>
          </li>
        </ul>
      </div>
    );
  }


  const buildProcessedRequest = (data) => {
    const alertStatus = (data?.alertStatus?.length !== 0 ) ? data?.alertStatus?.map(item => item.id) : undefined;
    const caseStatus = (data?.caseStatus?.length !== 0 ) ? data?.caseStatus?.map(item => item.id) : undefined;
    const tags = (data?.tags?.length !== 0 ) ? data?.tags?.map(item => item.id): undefined;
    const sports = (data?.sports?.length !== 0 ) ? data?.sports?.map(item => item.id) : undefined;
    const eSportsTitles = (data?.eSportsTitles?.length !== 0 ) ? data?.eSportsTitles?.map(item => item.id) : undefined;
    const tournamentLevels = (data?.tournamentLevels?.length !== 0 ) ? data?.tournamentLevels?.map(item => item.id) : undefined;
    const alertType = (data?.alertType?.length !== 0 ) ? data?.alertType?.map(item => item.id) : undefined;
    const responseType = (data?.responseType?.length !== 0 ) ? data?.responseType?.map(item => item.id) : undefined;
    const groups = (data?.company?.length !== 0 ) ? data?.company?.map(item => item.id) : undefined;

    const startDate = data?.date?.date ? formatDateRange(data?.date?.date[0]): undefined;
    const endDate = data?.date?.date ? formatDateRange(data?.date?.date[1]) : undefined;

    const eventStartDate = data?.eventDate?.date ? formatDateRange(data?.eventDate?.date[0]): undefined;
    const eventEndDate = data?.eventDate?.date ? formatDateRange(data?.eventDate?.date[1]) : undefined;

    const tournaments = (data?.tournament?.length !== 0 ) ? data?.tournament?.map(item => item.id) : undefined;
    const locations = (data?.location?.length !== 0 ) ? data?.location?.map(item => item.id) : undefined;
    const gender = (data?.gender?.length !== 0 ) ? data?.gender?.map(item => item.id) : undefined;

    const channel = (data?.channel?.length !== 0 ) ? data?.channel?.map(item => item.id) : undefined;
    const timeOfBet = (data?.timeOfBet?.length !== 0 ) ? data?.timeOfBet?.map(item => item.id) : undefined;
    const stateOfBet = (data?.stateOfBet?.length !== 0 ) ? data?.stateOfBet?.map(item => item.id) : undefined;
    const timeOfAlert = (data?.timeOfAlert?.length !== 0 ) ? data?.timeOfAlert?.map(item => item.id) : undefined;

    const maxBets = (data?.maxBets?.length !== 0 ) ? data?.maxBets?.map(item => item.name) : undefined;
    const maxBetsBoolean = maxBets?.length>0 ? staticOptionData?.confirmOptions?.filter(item => item.name === maxBets[0]).map(item => item.id)[0] : undefined;

    const keyword = data.keyword ? data.keyword : undefined;
    let customerLocations = undefined;
    if(data?.customerLocations?.length){
        const stateList =  data?.customerStates?.length ?  data?.customerStates.map(s => s.id) : []
        customerLocations =  data?.customerLocations.map(d => {
            const locationData = d.states?.length ? { name: d.name, states: d.states.filter(id => stateList.includes(id))} :  { name: d.name, };
            return locationData;
        })
    }
    let suspiciousCustomerLocations = undefined;
    if(data?.suspiciousCustomerLocations?.length){
        const stateList = data?.suspiciousCustomerStates?.length ? data.suspiciousCustomerStates.map((state) => state.id) : [];
        suspiciousCustomerLocations = data.suspiciousCustomerLocations.map((location) => (
          location.states?.length
            ? { name: location.name, states: location.states.filter((id) => stateList.includes(id)) }
            : { name: location.name }
        ));
    }
    return {
      alertStatus,
      caseStatus,
      tags,
      sports,
      eSportsTitles,
      tournamentLevels,
      alertType,
      responseType,
      groups,
      startDate,
      endDate,
      eventStartDate,
      eventEndDate,
      tournaments,
      locations,
      customerLocations,
      suspiciousCustomerLocations,
      gender,
      channel,
      timeOfBet,
      stateOfBet,
      timeOfAlert,
      maxBets: maxBetsBoolean,
      keyword
    };
  };

  const preSelectedSavedFilters = (savedFilter) => {
    resetFilters()
    setSelectedSavedFilter(savedFilter);
    const f = savedFilter.filters || {};

    const mapByNameOrId = (names = []) => {
      const checked = {};
      names?.forEach((id) => {
       checked[id] = true;
      });
      return checked;
    };

    // status mapping
    if (f.combinedStatus) {
      const checked = {};
      status.forEach((s) => {
        if (f.combinedStatus.includes(s.id) || f.combinedStatus.includes(s.name)) checked[s.id] = true;
        const code = s.id.split("-")[0];
        if (f.alertStatus && f.alertStatus.includes(code)) checked[s.id] = true;
      });
      setCheckedStatus(checked);
    } else if (f.alertStatus || f.caseStatus) {
      const checked = {};
      status.forEach((s) => {
        const parts = s.id.split("-");
        const a = parts[0];
        const c = parts[1];
        if (f.alertStatus && f.alertStatus.includes(a)) checked[s.id] = true;
        if (f.caseStatus && f.caseStatus.includes(c)) checked[s.id] = true;
      });
      setCheckedStatus(checked);
    }

    // players / tags
    if (f.tags) {
      setCheckedPlayers(mapByNameOrId(f.tags));
      setCheckedMarketTags(mapByNameOrId(f.tags));
    }

    // sports
    if (f.sports) {
      const checked = mapByNameOrId(f.sports);
      setCheckedSports(checked);
      const ids = (sports || []).filter((sport) => f.sports.some((name) => String(sport.id) === String(name) || sport.name?.toLowerCase() === String(name).toLowerCase())).map((s) => s.id);
      setSportIds(ids);
    }

    // eSports / tournament levels
    if (f.eSportsTitles) setCheckedeSportsTitles(mapByNameOrId(f.eSportsTitles));
    if (f.tournamentLevels ) setCheckedTournamentLevels(mapByNameOrId(f.tournamentLevels));

    // alert / response types
    if (f.alertType) setCheckedAlerts(mapByNameOrId(f.alertType));
    if (f.responseType) setCheckedResponses(mapByNameOrId(f.responseType));
    // company / receiver
    if (f.groups) setCheckedCompanies(mapByNameOrId(f.groups));
    if (f.receiver) setCheckedReceivers(mapByNameOrId(f.receiver));

    // dates
    if (f.startDate && f.endDate) {
      const sd = new Date(f.startDate);
      const ed = new Date(f.endDate);
      setDate([sd, ed]);
      setDateRange(`${formatShortDate(sd)} - ${formatShortDate(ed)}`);
    }
    if (f.eventStartDate && f.eventEndDate) {
      const sd2 = new Date(f.eventStartDate);
      const ed2 = new Date(f.eventEndDate);
      setEventDate([sd2, ed2]);
      setEventDateRange(`${formatShortDate(sd2)} - ${formatShortDate(ed2)}`);
    }

    // tournaments / locations / customer locations & states
    if (f.tournaments) setCheckedTournaments(mapByNameOrId(f.tournaments));
    if (f.locations) setCheckedLocations(mapByNameOrId(f.locations));

    if (f.customerLocations) {
      const checkedCustomer = {};
      const checkedStatesMap = {};
      const selectedLocationIds = [];
      f.customerLocations.forEach((cl) => {
        const loc = locations.find(l => l?.name === cl?.name);
        if (loc) {
          checkedCustomer[loc.id] = true;
          selectedLocationIds.push(loc.id);
        }
        if (cl.states && loc) {
          cl.states.forEach((sid) => {
            checkedStatesMap[sid] = true;
          });
        }
      });
      setCheckedCustomerLocations(checkedCustomer);
      setCheckedStates(checkedStatesMap);
      // ensure dependent states are loaded
      if (selectedLocationIds.length) {
        getStateList(selectedLocationIds, f.customerStates || []);
      }
    } else if (f.customerStates) {
      const csMap = {};
      (f.customerStates || []).forEach((s) => (csMap[s] = true));
      setCheckedStates(csMap);
    }
    if (f.suspiciousCustomerLocations) {
      const checkedSuspiciousCustomer = {};
      const checkedSuspiciousStates = {};
      const selectedLocationIds = [];
      f.suspiciousCustomerLocations.forEach((customerLocation) => {
        const location = locations.find((item) => item?.name === customerLocation?.name);
        if (location) {
          checkedSuspiciousCustomer[location.id] = true;
          selectedLocationIds.push(location.id);
        }
        customerLocation.states?.forEach((stateId) => {
          checkedSuspiciousStates[stateId] = true;
        });
      });
      setCheckedSuspiciousCustomerLocations(checkedSuspiciousCustomer);
      setCheckedSuspiciousCustomerStates(checkedSuspiciousStates);
      if (selectedLocationIds.length) {
        const selectedSuspiciousStates = f.suspiciousCustomerLocations
          .flatMap((customerLocation) => customerLocation.states || [])
          .map((id) => ({ id }));
        getSuspiciousCustomerStateList(selectedLocationIds, selectedSuspiciousStates, 'onload');
      }
    }

    // gender
    if (f.gender) setCheckedGenders(mapByNameOrId(f.gender));

    // channel / timeOfBet / stateOfBet / timeOfAlert
    if (f.channel) setCheckedChannel(mapByNameOrId(f.channel));
    if (f.timeOfBet) setCheckedTimeOfBet(mapByNameOrId(f.timeOfBet));
    if (f.stateOfBet) setCheckedStateOfBet(mapByNameOrId(f.stateOfBet));
    if (f.timeOfAlert) setCheckedAlertsRaised(mapByNameOrId(f.timeOfAlert));
    // max bets
    if (f.maxBets === true || f.maxBets === false) {
      setCheckedMaxBet(f.maxBets === true ? 'yes': 'no');
    }

    if (f.reportType) setCheckedReportTypes(mapByNameOrId(f.reportType));
    if (f.keyword !== undefined) setKeywords(f.keyword || "");
    if (f.search !== undefined) setKeywords(f.search || "");

  };

  return (
    <>
      <div className={`filter-dialog-body-section ${
          role === 'regulator'
          ? 'regulator'
          : role === 'member'
          ? 'member'
          : role === 'analyst'
          ? 'analyst'
          : role === 'managedmember'
          ? 'member'
          : role === 'governingbody'
          ? 'regulator'
          : ''
      }`}>
        <div className="grid grid-nogutter">
           <div className="col-12">
            {screenType === 'alerts' &&
             <SavedFilters
               getCurrentFilters={() => buildProcessedRequest(buildGlobalFilters())}
               onResetFilters={resetFilters}
               preSelectedSavedFilters={preSelectedSavedFilters}
               selectedFilter={selectedSavedFilter}
               screenType={'alert'}
             />
             }
           </div>
          <div className="col-9">
            <style>{`
              .search-filter-tabview .p-tabview-nav-container,
              .search-filter-tabview .p-tabview-panels {
                min-height: 660px;
                max-height: 660px;
                overflow-y: auto;
                min-width: 230px;
                border-right: 1px solid #F5F5F7;
              }
            `}</style>
            <PR.TabView
              className="search-filter-tabview"
              activeIndex={activeIndex}
              onTabChange={(e) => tabChangeHandler(e.index)}
            >
              {(<PR.TabPanel header="Keyword">
                <div className="flex filter-options-section">
                  <div className="filters-list">
                    <div className="mb-3">
                      <div className="flex align-items-center w-12 sticky-search">
                        <span className="p-input-icon-left w-12">
                          <i className="pi pi-search" />
                          <PR.InputText
                            id="keywordSearch"
                            placeholder="Enter Keyword"
                            className="search-box"
                            value={keywords}
                            onChange={({ target: { value } }) => {
                              if (value.length <= queryLimit) {
                                setKeywords(value)
                              } else {
                                setError(`Keyword can be at most ${queryLimit} characters long`);
                                setTimeout(() => {
                                  setError(null)
                                }, 2500)
                              }
                            }}
                          />
                        </span>
                        <span className="search-clear-icon custom-top">
                          {!!keywords && <i style={{ cursor: 'pointer', color: "#6c757d" }} onClick={() => setKeywords("")} className="pi pi-times text-sm mr-2" />}
                        </span>
                      </div>
                      {error && <p className="error-message mt-2">{error}</p>}
                    </div>
                    <span> {!doesReportScreen ? 'This will search in Event Name, Description and Advice.' : 'This will search in Title and Description.'}</span>
                  </div>
                </div>
              </PR.TabPanel>)}
              {(doesAlertsScreen && !(role === "member" && pathname === "/alerts" && alertsActiveIndex === 2)) && (
                <PR.TabPanel header="Status" disabled={isStatusTabDisabled}>
                  <div className="flex filter-options-section">
                    <div className="filters-list">
                      <div className="flex flex-wrap gap-3">
                        {status?.map((row, index) => (
                          <div
                            className="flex align-items-center status-box"
                            key={index}
                          >
                            <PR.Checkbox
                              value={row.id}
                              inputId={row.id}
                              checked={checkedStatus[row.id]}
                              onChange={handleCheckboxChange(setCheckedStatus)}
                            ></PR.Checkbox>
                            <label
                              htmlFor={row.id}
                              className="ml-2 font-medium"
                            >
                              {row.name}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </PR.TabPanel>
              )}
              {isPlayerVisible() && (
                <PR.TabPanel header="Athlete/Team Tags">
                  <div className="flex filter-options-section">
                    <div className="flex align-items-center w-12 mb-2 sticky-search">
                      <span className="p-input-icon-left w-12">
                        <i className="pi pi-search" />
                        <PR.InputText
                          id="playerSearch"
                          placeholder="Search"
                          className="search-box"
                          value={playerSearch}
                          autoComplete="off"
                          onChange={(event) => handleSearch(event, setPlayerSearch, playerNames, setFilteredPlayers)}
                        />
                      </span>
                      <span className="search-clear-icon">
                        {!!playerSearch &&
                          <i style={{ cursor: 'pointer', color: "#6c757d" }}
                            onClick={() => handleSearch({ target: { value: "" } }, setPlayerSearch, playerNames, setFilteredPlayers)}
                            className="pi pi-times text-sm mr-2" />
                        }
                      </span>
                    </div>
                    <div className="filters-list">
                      <div className="flex flex-wrap gap-3 ">
                        {loading ? (
                          <div className="filter-loading">
                            <i className="pi pi-spin pi-spinner"></i> Loading..
                          </div>
                        ) : (
                          filteredPlayers &&
                          filteredPlayers?.map((player, index) => {
                            return (
                              <div className="flex align-items-center status-box" key={index}>
                                <PR.Checkbox
                                  inputId={player.id}
                                  value={player.id}
                                  checked={checkedPlayers[player.id]}
                                  onChange={handleCheckboxChange(setCheckedPlayers)}
                                ></PR.Checkbox>
                                <label htmlFor={player.id} className="ml-2 font-medium">
                                  {player.name}
                                </label>
                              </div>
                            );
                          })
                        )}
                      </div>
                    </div>
                  </div>
                </PR.TabPanel>
              )}
              {isPlayerVisible() && (
                <PR.TabPanel header="Market Tags">
                  <div className="flex filter-options-section">
                    <div className="flex align-items-center w-12 mb-2 sticky-search">
                      <span className="p-input-icon-left w-12">
                        <i className="pi pi-search" />
                        <PR.InputText
                          id="marketTagSearch"
                          placeholder="Search"
                          className="search-box"
                          value={marketTagSearch}
                          autoComplete="off"
                          onChange={(event) => handleSearch(event, setMarketTagSearch, marketTags, setFilteredMarketTags)}
                        />
                      </span>
                      <span className="search-clear-icon">
                        {!!marketTagSearch &&
                          <i style={{ cursor: 'pointer', color: "#6c757d" }}
                            onClick={() => handleSearch({ target: { value: "" } }, setMarketTagSearch, marketTags, setFilteredMarketTags)}
                            className="pi pi-times text-sm mr-2" />
                        }
                      </span>
                    </div>
                    <div className="filters-list">
                      <div className="flex flex-wrap gap-3 ">
                        {loading ? (
                          <div className="filter-loading">
                            <i className="pi pi-spin pi-spinner"></i> Loading..
                          </div>
                        ) : (
                          filteredMarketTags &&
                          filteredMarketTags?.map((tag, index) => {
                            return (
                              <div className="flex align-items-center status-box" key={index}>
                                <PR.Checkbox
                                  inputId={tag.id}
                                  value={tag.id}
                                  checked={checkedMarketTags[tag.id]}
                                  onChange={handleCheckboxChange(setCheckedMarketTags)}
                                ></PR.Checkbox>
                                <label htmlFor={tag.id} className="ml-2 font-medium">
                                  {tag.name}
                                </label>
                              </div>
                            );
                          })
                        )}
                      </div>
                    </div>
                  </div>
                </PR.TabPanel>
              )}
              <PR.TabPanel header="Sports">
                <div className="flex filter-options-section">
                    <div className="flex align-items-center w-12 mb-2 sticky-search">
                      <span className="p-input-icon-left w-12">
                        <i className="pi pi-search" />
                        <PR.InputText
                          id="sportSearch"
                          placeholder="Search"
                          className="search-box"
                          value={searchSports}
                          autoComplete="off"
                          onChange={(event) => handleSearch(event, setSearchSports, sports, setFilteredSports)}
                        />
                      </span>
                      <span className="search-clear-icon">
                        {!!searchSports && <i style={{ cursor: 'pointer', color: "#6c757d" }} 
                        onClick={() => handleSearch({ target: { value: "" } }, setSearchSports, sports, setFilteredSports)} 
                        className="pi pi-times text-sm mr-2" />}
                      </span>
                    </div>
                  <div className="filters-list">
                    <div className="flex flex-wrap gap-3">
                      {loading ? (
                        <div className="filter-loading">
                          <i className="pi pi-spin pi-spinner"></i> Loading..
                        </div>
                      ) : (<>
                        {
                          filteredSports && filteredSports.map((sport, index) => (
                            <div className="flex align-items-center status-box" key={index} >
                              <PR.Checkbox
                                inputId={sport.id}
                                value={sport.id}
                                onChange={handleCheckboxChange(setCheckedSports, 'sport')}
                                checked={checkedSports[sport.id]}
                              ></PR.Checkbox>
                              <label htmlFor={sport.id} className="ml-2 font-medium">{sport.name}</label>
                            </div>
                          ))
                        }
                      </>
                      )}
                    </div>
                  </div>
                </div>
              </PR.TabPanel>

              {(doesAlertsScreen) && (
                <PR.TabPanel
                  header="Esports Titles"
                  disabled={disableeSportsTitles}
                >
                  <div className="flex filter-options-section">
                    <div className="flex align-items-center w-12 mb-2 sticky-search">
                      <span className="p-input-icon-left w-12">
                        <i className="pi pi-search" />
                        <PR.InputText
                          id="eSportsTitlesSearch"
                          placeholder="Search"
                          className="search-box"
                          value={eSportTitleSearch}
                          onChange={(event) => handleSearch(event, setESportTitleSearch, eSportsTitleList, setFilteredeSportsTitles)}
                        />
                      </span>
                      <span className="search-clear-icon">
                        {!!eSportTitleSearch &&
                          <i style={{ cursor: 'pointer', color: "#6c757d" }}
                            onClick={() => handleSearch({ target: { value: "" } }, setESportTitleSearch, eSportsTitleList, setFilteredeSportsTitles)}
                            className="pi pi-times text-sm mr-2" />
                        }
                      </span>
                    </div>
                    <div className="filters-list">
                      <div className="flex flex-wrap gap-3">
                        {loading ? (
                          <div className="filter-loading">
                            <i className="pi pi-spin pi-spinner"></i> Loading..
                          </div>
                        ) : (
                          filteredeSportsTitles &&
                          filteredeSportsTitles?.map((eSportsTitles, index) => (
                            <div
                              className="flex align-items-center status-box"
                              key={index}
                            >
                              <PR.Checkbox
                                inputId={eSportsTitles.id}
                                value={eSportsTitles.id}
                                onChange={handleCheckboxChange(setCheckedeSportsTitles)}
                                checked={checkedeSportsTitles[eSportsTitles.id]}
                              ></PR.Checkbox>
                              <label
                                htmlFor={eSportsTitles.id}
                                className="ml-2 font-medium"
                              >
                                {eSportsTitles.name}
                              </label>
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  </div>
                </PR.TabPanel>
              )}

              {doesAlertsScreen && (
                <PR.TabPanel
                  header="Tournament Levels"
                  disabled={disableTournamentLevel}
                >
                  <div className="flex filter-options-section">
                    <div className="flex align-items-center w-12 mb-2 sticky-search">
                        <span className="p-input-icon-left w-12">
                          <i className="pi pi-search" />
                          <PR.InputText
                            id="tournamentSearch"
                            placeholder="Search"
                            className="search-box"
                            value={tournmentSearch}
                            onChange={(event) => handleSearch(event, setTournmentSearch, tournamentLevelsList, setFilteredTournamentLevels)}

                          />
                        </span>
                        <span className="search-clear-icon">
                          {!!tournmentSearch &&
                            <i style={{ cursor: 'pointer', color: "#6c757d" }}
                              onClick={() => handleSearch({ target: { value: "" } }, setTournmentSearch, tournamentLevelsList, setFilteredTournamentLevels)}
                              className="pi pi-times text-sm mr-2" />
                          }
                        </span>
                      </div>
                    <div className="filters-list">
                      <div className="flex flex-wrap gap-3">
                        {loading ? (
                          <div className="filter-loading">
                            <i className="pi pi-spin pi-spinner"></i> Loading..
                          </div>
                        ) : (
                          filteredTournamentLevels &&
                          filteredTournamentLevels?.map((tournamentLevel, index) => (
                            <div
                              className="flex align-items-center status-box"
                              key={index}
                            >
                              <PR.Checkbox
                                inputId={tournamentLevel.id}
                                value={tournamentLevel.id}
                                onChange={handleCheckboxChange(setCheckedTournamentLevels)}
                                checked={checkedTournamentLevels[tournamentLevel.id]}
                              ></PR.Checkbox>
                              <label
                                htmlFor={tournamentLevel.id}
                                className="ml-2 font-medium"
                              >
                                {tournamentLevel.name}
                              </label>
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  </div>
                </PR.TabPanel>
              )}

              {doesAlertsScreen && (
                <PR.TabPanel header="Alert Type">
                  <div className="flex filter-options-section">
                    <div className="filters-list">
                      <div className="flex flex-wrap gap-3">
                        {alertTypes?.map((alert, index) => (
                          <div
                            className="flex align-items-center status-box"
                            key={index}
                          >
                            <PR.Checkbox
                              inputId={alert.id}
                              value={alert.id}
                              onChange={handleCheckboxChange(setCheckedAlerts)}
                              checked={checkedAlerts[alert.id]}
                            ></PR.Checkbox>
                            <label htmlFor={alert.id} className="ml-2 font-medium">
                              {alert.name}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </PR.TabPanel>
              )}
              {doesAlertsScreen && (
                <PR.TabPanel header="Response Type">
                  <div className="flex filter-options-section">
                    <div className="filters-list">
                      <div className="flex flex-wrap gap-3">
                        {responseTypes?.map((response, index) => (
                          <div
                            className="flex align-items-center status-box"
                            key={index}
                          >
                            <PR.Checkbox
                              inputId={response.id}
                              value={response.id}
                              onChange={handleCheckboxChange(setCheckedResponses)}
                              checked={checkedResponses[response.id]}
                            ></PR.Checkbox>
                            <label htmlFor={response.id} className="ml-2 font-medium">
                              {response.name}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </PR.TabPanel>
              )}
              {doesAlertsScreen && (
                <PR.TabPanel header="Company" disabled={isCompanyTabDisabled}>
                  <div className="flex filter-options-section">
                      <div className="flex align-items-center w-12 mb-2 sticky-search">
                        <span className="p-input-icon-left w-12">
                          <i className="pi pi-search" />
                          <PR.InputText
                            id="companySearch"
                            placeholder="Search"
                            className="search-box"
                            value={companySearch}
                            onChange={(event) => handleSearch(event, setCompanySearch, companies, setFilteredCompanies)}

                          />
                        </span>
                        <span className="search-clear-icon">
                          {!!companySearch &&
                            <i style={{ cursor: 'pointer', color: "#6c757d" }}
                              onClick={() => handleSearch({ target: { value: "" } }, setCompanySearch, companies, setFilteredCompanies)}
                              className="pi pi-times text-sm mr-2" />}
                        </span>
                      </div>
                    <div className="filters-list">
                      <div className="flex flex-wrap gap-3">
                        {loading ? (
                          <div className="filter-loading">
                            <i className="pi pi-spin pi-spinner"></i> Loading..
                          </div>
                        ) : (
                          filteredCompanies &&
                          filteredCompanies?.map((member, index) => {
                            return (
                              <div
                                className="flex align-items-center status-box"
                                key={index}
                              >
                                <PR.Checkbox
                                  inputId={member.id}
                                  value={member.id}
                                  onChange={handleCheckboxChange(setCheckedCompanies)}
                                  checked={checkedCompanies[member.id]}
                                ></PR.Checkbox>
                                <label
                                  htmlFor={member.id}
                                  className="ml-2 font-medium"
                                >
                                  {member.name}
                                </label>
                              </div>
                            );
                          })
                        )}
                      </div>
                    </div>
                  </div>
                </PR.TabPanel>
              )}
              <PR.TabPanel header="Created Date">
                <div className="filter-options-section">
                  <div className="card date-calendar flex justify-content-center">
                    <PR.Calendar
                      name="date"
                      value={date}
                      inputId="searchDate"
                      onChange={handleDateRange}
                      inline
                      selectionMode="range"
                      maxDate={new Date()}
                    />
                  </div>
                </div>
              </PR.TabPanel>
              {doesAlertsScreen && (
                <PR.TabPanel header="Event Date">
                  <div className="filter-options-section">
                    <div className="card date-calendar flex justify-content-center">
                      <PR.Calendar
                        name="eventDate"
                        value={eventDate}
                        inputId="eventDate"
                        onChange={handleEventDateRange}
                        inline
                        selectionMode="range"
                        maxDate={new Date()}
                      />
                    </div>
                  </div>
                </PR.TabPanel>
              )}
              {(doesAlertsScreen)&& (
                <PR.TabPanel
                  header="Tournament / League"
                  disabled={sportIds?.length === 0 || sportIds === undefined}
                >
                  <div className="flex filter-options-section">
                    <div className="flex align-items-center w-12 mb-2 sticky-search">
                        <span className="p-input-icon-left w-12">
                          <i className="pi pi-search" />
                          <PR.InputText
                            id="leagueSearch"
                            placeholder="Search"
                            className="search-box"
                            value={leagueSearch}
                            onChange={(event) => handleSearch(event, setLeagueSearch, tournamentsList, setFilteredTournaments)}

                          />
                        </span>
                        <span className="search-clear-icon">
                          {!!leagueSearch && <i style={{ cursor: 'pointer', color: "#6c757d" }}
                            onClick={() => handleSearch({ target: { value: "" } }, setLeagueSearch, tournamentsList, setFilteredTournaments)}
                            className="pi pi-times text-sm mr-2" />}
                        </span>
                      </div>
                    <div className="filters-list">
                      <div className="flex flex-wrap gap-3">
                        {loading ? (
                          <div className="filter-loading">
                            <i className="pi pi-spin pi-spinner"></i> Loading..
                          </div>
                        ) : (
                          filteredTournaments &&
                          filteredTournaments?.map((tournament, index) => (
                            <div
                              className="flex align-items-center status-box"
                              key={index}
                            >
                              <PR.Checkbox
                                inputId={tournament.id}
                                value={tournament.id}
                                onChange={handleCheckboxChange(setCheckedTournaments)}
                                checked={checkedTournaments[tournament.id]}
                              ></PR.Checkbox>
                              <label
                                htmlFor={tournament.id}
                                className="ml-2 font-medium"
                              >
                                {tournament.name}
                              </label>
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  </div>
                </PR.TabPanel>
              )}
              {doesAlertsScreen && (
                <PR.TabPanel header="Gender">
                  <div className="flex filter-options-section">
                    <div className="filters-list">
                      <div className="flex flex-wrap gap-3">
                        {gender?.map((row, index) => (
                          <div
                            className="flex align-items-center status-box"
                            key={index}
                          >
                            <PR.Checkbox
                              inputId={row.id}
                              value={row.id}
                              onChange={handleCheckboxChange(setCheckedGenders)}
                              checked={checkedGenders[row.id]}
                            ></PR.Checkbox>
                            <label htmlFor={row.id} className="ml-2 font-medium">
                              {row.name}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </PR.TabPanel>
              )}
              {(doesAlertsScreen)&& (
                <PR.TabPanel header="Location">
                  <div className="flex filter-options-section">
                    <div className="flex align-items-center w-12 mb-2 sticky-search">
                        <span className="p-input-icon-left w-12">
                          <i className="pi pi-search" />
                          <PR.InputText
                            id="locationSearch"
                            placeholder="Search"
                            className="search-box"
                            value={locatinSearch}
                            onChange={(event) => handleSearch(event, setLocationSearch, locations, setFilteredLocations)}

                          />
                        </span>
                        <span className="search-clear-icon">
                          {!!locatinSearch &&
                            <i style={{ cursor: 'pointer', color: "#6c757d" }}
                              onClick={() => handleSearch({ target: { value: "" } }, setLocationSearch, locations, setFilteredLocations)}
                              className="pi pi-times text-sm mr-2" />}
                        </span>
                      </div>
                    <div className="filters-list">
                      <div className="flex flex-wrap gap-3">
                        {loading ? (
                          <div className="filter-loading">
                            <i className="pi pi-spin pi-spinner"></i> Loading..
                          </div>
                        ) : (
                          filteredLocations &&
                          filteredLocations?.map((location, index) => {
                            return (
                              <div
                                className="flex align-items-center status-box"
                                key={index}
                              >
                                <PR.Checkbox
                                  inputId={location.id}
                                  value={location.id}
                                  onChange={handleCheckboxChange(setCheckedLocations)}
                                  checked={checkedLocations[location.id]}
                                ></PR.Checkbox>
                                <label
                                  htmlFor={location.id}
                                  className="ml-2 font-medium"
                                >
                                  {location.name}
                                </label>
                              </div>
                            );
                          })
                        )}
                      </div>
                    </div>
                  </div>
                </PR.TabPanel>
              )}
              {doesAlertsScreen && (
                <PR.TabPanel header="Customer Location">
                  <div className="flex filter-options-section">
                    <div className="flex align-items-center w-12 mb-2 sticky-search">
                        <span className="p-input-icon-left w-12">
                          <i className="pi pi-search" />
                          <PR.InputText
                            id="customerLocationSearch"
                            placeholder="Search"
                            className="search-box"
                            value={customerLocationSearch}
                            onChange={(event) => handleSearch(event, setCustomerLocationSearch, locations, setFilteredCustomerLocations)}

                          />
                        </span>
                        <span className="search-clear-icon">
                          {!!customerLocationSearch &&
                            <i style={{ cursor: 'pointer', color: "#6c757d" }}
                              onClick={() => handleSearch({ target: { value: "" } }, setCustomerLocationSearch, locations, setFilteredCustomerLocations)}
                              className="pi pi-times text-sm mr-2" />}
                        </span>
                      </div>
                    <div className="filters-list">
                      <div className="flex flex-wrap gap-3">
                        {loading ? (
                          <div className="filter-loading">
                            <i className="pi pi-spin pi-spinner"></i> Loading..
                          </div>
                        ) : (
                          filteredCustomerLocations &&
                          filteredCustomerLocations?.map((location, index) => {
                            return (
                              <div
                                className="flex align-items-center status-box"
                                key={index}
                              >
                                <PR.Checkbox
                                  inputId={`${location.id}customer`}
                                  value={location.id}
                                  onChange={handleCheckboxChange(setCheckedCustomerLocations, 'locations')}
                                  checked={checkedCustomerLocations[location.id]}
                                ></PR.Checkbox>
                                <label
                                  htmlFor={`${location.id}customer`}
                                  className="ml-2 font-medium"
                                >
                                  {location.name}
                                </label>
                              </div>
                            );
                          })
                        )}
                      </div>
                    </div>
                  </div>
                </PR.TabPanel>
              )}
              {!doesReportScreen && (
                <PR.TabPanel header="Customer State" disabled={!states.length}>
                  <div className="flex filter-options-section">
                    <div className="filters-list">
                      <div className="flex align-items-center w-12 mb-3 sticky-search">
                        <span className="p-input-icon-left w-12">
                          <i className="pi pi-search" />
                          <PR.InputText
                            id="stateSearch"
                            placeholder="Search"
                            className="search-box"
                            value={stateSearch}
                            onChange={(event) => handleSearch(event, setStateSearch, states, setFilteredStates)}

                          />
                        </span>
                        <span className="search-clear-icon">
                          {!!stateSearch &&
                            <i style={{ cursor: 'pointer', color: "#6c757d" }}
                              onClick={() => handleSearch({ target: { value: "" } }, setStateSearch, states, setFilteredStates)}
                              className="pi pi-times text-sm mr-2" />}
                        </span>
                      </div>
                      <div className="flex flex-wrap gap-3">
                        {loading ? (
                          <div>
                            <i className="pi pi-spin pi-spinner"></i>
                          </div>
                        ) : (
                          filteredStates &&
                          filteredStates?.map((state, index) => {
                            return (
                              <div
                                className="flex align-items-center status-box"
                                key={index}
                              >
                                <PR.Checkbox
                                  inputId={`${state.id}`}
                                  value={state.id}
                                  onChange={handleCheckboxChange(setCheckedStates)}
                                  checked={checkedStates[state.id]}
                                ></PR.Checkbox>
                                <label
                                  htmlFor={`${state.id}`}
                                  className="ml-2 font-medium"
                                >
                                  {state.name}
                                </label>
                              </div>
                            );
                          })
                        )}
                      </div>
                    </div>
                  </div>
                </PR.TabPanel>
              )}
              {doesAlertsScreen && (
                <PR.TabPanel header="Suspicious Customer Location">
                  <div className="flex filter-options-section">
                    <div className="flex align-items-center w-12 mb-2 sticky-search">
                      <span className="p-input-icon-left w-12">
                        <i className="pi pi-search" />
                        <PR.InputText
                          id="suspiciousCustomerLocationSearch"
                          placeholder="Search"
                          className="search-box"
                          value={suspiciousCustomerLocationSearch}
                          onChange={(event) => handleSearch(event, setSuspiciousCustomerLocationSearch, locations, setFilteredSuspiciousCustomerLocations)}
                        />
                      </span>
                      <span className="search-clear-icon">
                        {!!suspiciousCustomerLocationSearch &&
                          <i
                            style={{ cursor: 'pointer', color: "#6c757d" }}
                            onClick={() => handleSearch({ target: { value: "" } }, setSuspiciousCustomerLocationSearch, locations, setFilteredSuspiciousCustomerLocations)}
                            className="pi pi-times text-sm mr-2"
                          />}
                      </span>
                    </div>
                    <div className="filters-list">
                      <div className="flex flex-wrap gap-3">
                        {loading ? (
                          <div className="filter-loading"><i className="pi pi-spin pi-spinner"></i> Loading..</div>
                        ) : (
                          filteredSuspiciousCustomerLocations?.map((location) => (
                            <div className="flex align-items-center status-box" key={location.id}>
                              <PR.Checkbox
                                inputId={`${location.id}suspiciousCustomer`}
                                value={location.id}
                                onChange={handleCheckboxChange(setCheckedSuspiciousCustomerLocations, 'suspiciousLocations')}
                                checked={checkedSuspiciousCustomerLocations[location.id]}
                              />
                              <label htmlFor={`${location.id}suspiciousCustomer`} className="ml-2 font-medium">
                                {location.name}
                              </label>
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  </div>
                </PR.TabPanel>
              )}
              {doesAlertsScreen && (
                <PR.TabPanel header="Suspicious Customer State" disabled={!suspiciousCustomerStates.length}>
                  <div className="flex filter-options-section">
                    <div className="filters-list">
                      <div className="flex align-items-center w-12 mb-3 sticky-search">
                        <span className="p-input-icon-left w-12">
                          <i className="pi pi-search" />
                          <PR.InputText
                            id="suspiciousCustomerStateSearch"
                            placeholder="Search"
                            className="search-box"
                            value={suspiciousCustomerStateSearch}
                            onChange={(event) => handleSearch(event, setSuspiciousCustomerStateSearch, suspiciousCustomerStates, setFilteredSuspiciousCustomerStates)}
                          />
                        </span>
                        <span className="search-clear-icon">
                          {!!suspiciousCustomerStateSearch &&
                            <i
                              style={{ cursor: 'pointer', color: "#6c757d" }}
                              onClick={() => handleSearch({ target: { value: "" } }, setSuspiciousCustomerStateSearch, suspiciousCustomerStates, setFilteredSuspiciousCustomerStates)}
                              className="pi pi-times text-sm mr-2"
                            />}
                        </span>
                      </div>
                      <div className="flex flex-wrap gap-3">
                        {filteredSuspiciousCustomerStates?.map((state) => (
                          <div className="flex align-items-center status-box" key={state.id}>
                            <PR.Checkbox
                              inputId={`${state.id}suspiciousCustomerState`}
                              value={state.id}
                              onChange={handleCheckboxChange(setCheckedSuspiciousCustomerStates)}
                              checked={checkedSuspiciousCustomerStates[state.id]}
                            />
                            <label htmlFor={`${state.id}suspiciousCustomerState`} className="ml-2 font-medium">
                              {state.name}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </PR.TabPanel>
              )}
              {role === "analyst" && doesReportScreen ? (
                <PR.TabPanel header="Report Type">
                  <div className="flex filter-options-section">
                    <div className="filters-list">
                      <div className="flex flex-wrap gap-3">
                        {staticOptionData?.reportTypeFilter?.map(
                          (reportType, index) => (
                            <div
                              className="flex align-items-center status-box"
                              key={index}
                            >
                              <PR.Checkbox
                                inputId={reportType.id}
                                value={reportType.id}
                                onChange={handleCheckboxChange(setCheckedReportTypes)}
                                checked={checkedReportTypes[reportType.id]}
                              />
                              <label
                                htmlFor={reportType.id}
                                className="ml-2 font-medium"
                              >
                                {reportType.name}
                              </label>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </PR.TabPanel>
              ) : null}
              {role === "analyst" && doesReportScreen && (
                <PR.TabPanel header="Receiver">
                  <div className="flex filter-options-section">
                      <div className="flex align-items-center w-12 mb-2 sticky-search">
                        <span className="p-input-icon-left w-12">
                          <i className="pi pi-search" />
                          <PR.InputText
                            id="receiverSearch"
                            placeholder="Search"
                            className="search-box"
                            value={receiverSearch}
                            onChange={(event) => handleSearch(event, setReceiverSearch, receivers, setFilteredReceivers)}
                          />
                        </span>
                        <span className="search-clear-icon">
                          {!!receiverSearch &&
                            <i style={{ cursor: 'pointer', color: "#6c757d" }}
                              onClick={() => handleSearch({ target: { value: "" } }, setReceiverSearch, receivers, setFilteredReceivers)}
                              className="pi pi-times text-sm mr-2" />}
                        </span>
                      </div>
                    <div className="filters-list">
                      <div className="flex flex-wrap gap-3">
                        {filteredReceivers && filteredReceivers?.map((receiver, index) => (
                          <div
                            className="flex align-items-center status-box"
                            key={index}
                          >
                            <PR.Checkbox
                              inputId={receiver.id}
                              value={receiver.id}
                              onChange={handleCheckboxChange(setCheckedReceivers)}
                              checked={checkedReceivers[receiver.id]}
                            />
                            <label htmlFor={receiver.id} className="ml-2 font-medium">
                              {receiver.name}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </PR.TabPanel>
              )}

              {(doesAlertsScreen) && (
                <PR.TabPanel header="Others">
                  <div className="filter-options-section">
                    <div className="other-tab">
                      <div className="col-12 mb-2">
                        <div className="flex flex-column gap-2">
                          <span className="label">
                            Channel
                          </span>
                          <div className="flex flex-wrap gap-3 mt-1">
                            {channel?.map((row, index) => (
                              <div
                                className="flex align-items-center"
                                key={index}
                              >
                                <PR.Checkbox
                                  inputId={row.id}
                                  value={row.id}
                                  onChange={handleCheckboxChange(setCheckedChannel)}
                                  checked={checkedChannel[row.id]}
                                ></PR.Checkbox>
                                <label
                                  htmlFor={row.id}
                                  className="ml-2 font-medium"
                                >
                                  {row.name}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                     { doesAlertsScreen &&
                      <>
                      <div className="col-12 mb-2">
                        <div className="flex flex-column gap-2">
                          <span className="label">
                            Time of bet
                          </span>
                          <div className="flex flex-wrap gap-3 mt-1">
                            {timeOfBet?.map((row, index) => (
                              <div
                                className="flex align-items-center"
                                key={index}
                              >
                                <PR.Checkbox
                                  inputId={`time-of-bet-${row.id}`}
                                  value={row.id}
                                  onChange={handleCheckboxChange(setCheckedTimeOfBet)}
                                  checked={checkedTimeOfBet[row.id]}
                                ></PR.Checkbox>
                                <label
                                  htmlFor={`time-of-bet-${row.id}`}
                                  className="ml-2 font-medium"
                                >
                                  {row.name}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="col-12 mb-2">
                        <div className="flex flex-column gap-2">
                          <span className="label">
                            State of the bets
                          </span>
                          <div className="flex flex-wrap gap-3 mt-1">
                            {stateOfBet?.map((row, index) => (
                              <div
                                className="flex align-items-center"
                                key={index}
                              >
                                <PR.Checkbox
                                  inputId={row.id}
                                  value={row.id}
                                  onChange={handleCheckboxChange(setCheckedStateOfBet)}
                                  checked={checkedStateOfBet[row.id]}
                                ></PR.Checkbox>
                                <label
                                  htmlFor={row.id}
                                  className="ml-2 font-medium"
                                >
                                  {row.name}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="col-12 mb-2">
                        <div className="flex flex-column gap-2">
                          <span className="label">
                            Max bets
                          </span>
                          <div className="card flex mt-1 gap-3">
                            {maxBet?.map((row, index) => (
                              <div className="flex flex-wrap gap-2" key={index}>
                                <div className="flex align-items-center">
                                  <PR.RadioButton
                                    inputId={row.id}
                                    name="bets"
                                    value={row.id}
                                    onChange={(e) => {
                                      maxBetRadioGroupHandler(e.value);
                                    }}
                                    checked={checkedMaxBet === row.id}
                                  />
                                  <label
                                    htmlFor={row.id}
                                    className="ml-2 font-medium"
                                  >
                                    {row.name}
                                  </label>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="flex flex-column gap-2">
                          <span className="label">
                            When is the alert being raised?
                          </span>
                          <div className="card flex mt-1 gap-3">
                            {alertsRaised?.map((row, index) => (
                              <div className="flex flex-wrap gap-2" key={index}>
                                <div className="flex align-items-center">
                                  <PR.Checkbox
                                    inputId={row.id}
                                    value={row.id}
                                    onChange={handleCheckboxChange(setCheckedAlertsRaised)}
                                    checked={checkedAlertsRaised[row.id]}
                                  ></PR.Checkbox>
                                  <label
                                    htmlFor={row.id}
                                    className="ml-2 font-medium"
                                  >
                                    {row.name}
                                  </label>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      </>}
                    </div>
                  </div>
                </PR.TabPanel>
              )}
            </PR.TabView>
          </div>
          <div className="col-3 right-section">
            <p className="filters_p">Selected Filters:</p>
            {locationError && <p className="error-message mt-2" style={{color:'red'}}>{locationError}</p>}
            <FilterItem
              label="Keyword"
              value={keywords}
              handleRemove={() => handleRemoveItemFilter('keyword')}
            />
            <FiltersList
              items={getSelectedStatus()}
              label="Status"
              setter={setCheckedStatus}
            />
            <FiltersList
              items={getSelectedPlayers()}
              label="Athlete/Team Tags"
              setter={setCheckedPlayers}
            />
            <FiltersList
              items={getSelectedMarketTags()}
              label="Market Tags"
              setter={setCheckedMarketTags}
            />
            <FiltersList
              items={getSelectedSports()}
              label="Sports"
              setter={setCheckedSports}
              type='sport'
            />
            <FiltersList
              items={getSelectedeSportsTitles()}
              label="Esports Titles"
              setter={setCheckedeSportsTitles}
            />
            <FiltersList
              items={getSelectedTournamentLevels()}
              label="Tournament Levels"
              setter={setCheckedTournamentLevels}

            />
            <FiltersList
              items={getSelectedAlerts()}
              label="Alert Type"
              setter={setCheckedAlerts}
            />
            <FiltersList
              items={getSelectedResponses()}
              label="Response Type"
              setter={setCheckedResponses}
            />
            <FiltersList
              items={getSelectedCompanies()}
              label="Company"
              setter={setCheckedCompanies}
            />
            <FilterItem
              label="Created Date"
              value={dateRange}
              handleRemove={() => handleRemoveItemFilter('date')}
            />
            <FilterItem
              label="Event Date"
              value={eventDateRange}
              handleRemove={() => handleRemoveItemFilter('event')}
            />
            <FiltersList
              items={getSelectedTournaments()}
              label="Tournament / League"
              setter={setCheckedTournaments}
            />
            <FiltersList
              items={getSelectedGenders()}
              label="Gender"
              setter={setCheckedGenders}
            />
            <FiltersList
              items={getSelectedLocations()}
              label="Location"
              setter={setCheckedLocations}
            />
            <FiltersList
              items={getSelectedCustomerLocations()}
              label="Customer Location"
              setter={setCheckedCustomerLocations}
              type='locations'
            />
            <FiltersList
              items={getSelectedStates()}
              label="Customer State"
              setter={setCheckedStates}
            />
            <FiltersList
              items={getSelectedSuspiciousCustomerLocations()}
              label="Suspicious Customer Location"
              setter={setCheckedSuspiciousCustomerLocations}
              type='suspiciousLocations'
            />
            <FiltersList
              items={getSelectedSuspiciousCustomerStates()}
              label="Suspicious Customer State"
              setter={setCheckedSuspiciousCustomerStates}
            />
            <FiltersList
              items={getSelectedReportTypes()}
              label="Report Type"
              setter={setCheckedReportTypes}
            />
            <FiltersList
              items={getSelectedReceivers()}
              label="Receiver"
              setter={setCheckedReceivers}
            />
            {othersTabFiltersSelected() && (
              <div className="filters-list mb-3">

                <p>Others:</p>
                <OtherFilterList
                  label="Channel"
                  items={getSelectedChannels()}
                  setter={setCheckedChannel}
                />
                <OtherFilterList
                  label="Time of bet"
                  items={getSelectedTimeOfBet()}
                  setter={setCheckedTimeOfBet}
                />
                <OtherFilterList
                  label="State of bets"
                  items={getSelectedStateOfBets()}
                  setter={setCheckedStateOfBet}
                />
                <OtherFilterList
                  label="Max bets"
                  items={getSelectedMaxBets()}
                  setter={setCheckedMaxBet}
                  type='max'
                />
                <OtherFilterList
                  label="Alert raised at"
                  items={getSelectedAlertsRaised()}
                  setter={setCheckedAlertsRaised}
                />
              </div>
            )}
          </div>
          <div className="col-12">
              {buttonSection()}
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchFilter;
